import React, { FunctionComponent } from 'react';
import { RiErrorWarningLine } from 'react-icons/ri';
import classNames from 'classnames';
import styles from './styles.module.scss';

interface Props {
  lockedOutMsg: string;
}
export const LockedOutModal: FunctionComponent<Props> = ({ lockedOutMsg }) => {
  return (
    <div
      className={classNames(styles.loginContainer, styles.lockedOutContainer)}
    >
      <div className={styles.warningBox}>
        <RiErrorWarningLine className={styles.warningIcon} />
        <div className={styles.errorHeader}>
          <div className={styles.warningTitle}>You've been locked out</div>
        </div>
      </div>
      <div className={styles.warningDetail}>{lockedOutMsg}</div>
    </div>
  );
};
